// extracted by mini-css-extract-plugin
module.exports = {"lia-occasion-rsvp":"OccasionRsvpInformation_lia-occasion-rsvp__o_2xL"};